import React from 'react'
import { kebabCase } from 'lodash'
import Accordion, { AccordionItem } from '@ublique/components/Accordion'

const MAX_NUMBER_OF_ERRORS = 10

const ErrorRow = ({ fieldName, rowNumber, reason, t }) => (
  <p>
    <span className='row'>
      {t('Shell:ImportRow')} {rowNumber}:
    </span>
    <span>
      <span>{fieldName} - </span>
      <span className='reason'>{t('ImportLog:' + reason)}</span>
    </span>
  </p>
)
const UploadErrorRow = ({ reason, t, idx }) => (
  <p className='accordion-body'>
    <span className='row'>{'- '}</span>
    <span>
      <span className='reason'>{t('UploadLog:' + reason)}</span>
    </span>
  </p>
)

const rowMapByType = { import: ErrorRow, upload: UploadErrorRow }

const ErrorsAccordion = ({ errorsBySheetList, t, type = 'import' }) => {
  const AccordionRow = rowMapByType[type]

  return (
    <Accordion>
      {errorsBySheetList.map(([sheetName, errors]) => {
        const slicedErrors = errors.slice(0, MAX_NUMBER_OF_ERRORS)
        const remainingErrors = errors.length - slicedErrors.length
        const key = kebabCase(sheetName)

        return (
          <AccordionItem
            key={key}
            title={sheetName}
            open={errorsBySheetList.length === 1}
          >
            <div className='errors-list'>
              {slicedErrors.map((error, i) => (
                <AccordionRow key={`${key}-${i}`} idx={i} t={t} {...error} />
              ))}
              {remainingErrors > 0 && (
                <p>
                  {t('Shell:ImportMoreError', {
                    count: remainingErrors
                  })}
                </p>
              )}
            </div>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default ErrorsAccordion
